type Props = {
  onProfileEdit: () => void;
  deleteOpen: () => void;
};

export default function CandidatesProfileMenu({ onProfileEdit, deleteOpen }: Props) {
  return (
    <div className="w-[180px] rounded bg-white shadow-[0px_0px_12px_0px_#00000033]">
      <button
        type="button"
        className="flex h-xxl w-full items-center justify-center text-sm hover:opacity-60"
        onClick={onProfileEdit}
      >
        プロフィールを編集する
      </button>
      <button
        type="button"
        className="flex h-xxl w-full items-center justify-center text-sm text-danger hover:opacity-60"
        onClick={deleteOpen}
      >
        求職者情報を削除する
      </button>
    </div>
  );
}
